import { ExportFormat, ExportDataType } from '../types/export.types'

const PREFIXES: Record<ExportDataType, string> = {
  collection: 'cigar-collection',
  sessions: 'smoke-sessions',
}

export async function downloadExport(
  dataType: ExportDataType,
  format: ExportFormat
): Promise<void> {
  const token = localStorage.getItem('accessToken')
  if (!token) {
    throw new Error('Not authenticated')
  }

  const endpoint = dataType === 'collection' ? 'collection' : 'sessions'
  const url = `/api/v1/export/${endpoint}?format=${format}`

  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  })

  if (!response.ok) {
    throw new Error(`Export failed: ${response.statusText}`)
  }

  const blob = await response.blob()
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = objectUrl
  const dateStr = new Date().toISOString().split('T')[0]
  link.download = `${PREFIXES[dataType]}-${dateStr}.${format}`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(objectUrl)
}
